import React, { useContext, useEffect, useState } from 'react';
import { Nav, Tab } from "react-bootstrap";
import utilsMaster from '../../../../MyConns/_Utils/utilsMaster';
import Breadcrumb from './Breadcrumb';

import { TheMasterContext } from '../../../MyContexts/Master_Context';
import { UserContext } from '../../../MyContexts/Users_Context';
import MySpinner_Wait from '../../../MySections/DTechComps/MySpinner_Wait';
import SucessToast from '../../../MySections/Toasts/SucessToast';
import DeliverMaster from './parts/DeliverMaster';
import StaticPages from './parts/StaticPages';
import SocialMediaLnks from './parts/SocialMdsTab';
import TabPopUps from './parts/TabPopUps';
import TabSiteDetails from './parts/TabSiteDetails';
import TabMainMenu from './parts/TabMainMenu';

import SEOs from './parts/SEOs';
import SocialMdsTab from './parts/SocialMdsTab';
import TabFooter from './parts/TabFooter';

const MasterSet = () => {
    const [theMaster, setTheMaster] = useContext(TheMasterContext);
    const [loading, setLoading] = useState(true);
    const [thePopUp, setThePopUp] = useState("");
    const [activeTab, setActiveTab] = useState("tab6");

    useEffect(() => {
        // Retrieve saved tab from localStorage or use default
        const savedTab = localStorage.getItem('activeTab');
        if (savedTab) {
            setActiveTab(savedTab);
        }
        getMaster();
    }, [])

    const getMaster = async () => {
        let mst = await utilsMaster.getMaster();
        setTheMaster(mst);
        setLoading(false);
    }

    const updateTheMaster = async () => {

        let rstLst = await utilsMaster.updateTheMaster(theMaster);
        setTheMaster({ ...theMaster })
        SucessToast({ position: "toast-bottom-right", text: "עודכן בהצלחה!" });

        setLoading(false);
    }

    // Save selected tab to localStorage when tab is selected
    const handleSelect = (selectedKey) => {
        setActiveTab(selectedKey);
        localStorage.setItem('activeTab', selectedKey);
    }

    return (
        <div className="ms-content-wrapper SetBlock">
            {loading ? (
                <MySpinner_Wait />
            ) : (
                <div className="col-md-12">
                    <Breadcrumb />
                    <div className="ms-panel ms-panel-fh">
                        <div className="ms-panel-header">
                            <h6>MASTER</h6>
                        </div>
                        <div className="ms-panel-body clearfix">
                            <Tab.Container activeKey={activeTab} onSelect={handleSelect}>
                                <Nav variant="tabs" className="nav nav-tabs d-flex nav-justified mb-2">
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab6">הזמנות ומשלוחים</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab1">פרטי האתר</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="sideMenu">תפריט צד</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab4">פופאפ</Nav.Link>
                                    </Nav.Item>

                                    <Nav.Item>
                                        <Nav.Link eventKey="tab10">רשתות חברתיות</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab8">עמודים סטאטים</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="tab9">קידום SEO</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey="tab1">
                                        <div className="form-row tabsInputs ">
                                            <TabSiteDetails />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="sideMenu">
                                        <div className="form-row tabsInputs ">
                                            <TabMainMenu />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab4">
                                        <div className="form-row tabsInputs ">
                                            <TabPopUps />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab6">
                                        <div className="form-row tabsInputs ">
                                            <DeliverMaster />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab10">
                                        <div className="form-row tabsInputs ">
                                            <SocialMdsTab />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab8">
                                        <div className="form-row tabsInputs ">
                                            <StaticPages />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="tab9">
                                        <div className="form-row tabsInputs ">
                                            <SEOs />
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            )}
            <div className="ms-panel-header approveLine">
                <button type="button" className="onLeft btn btn-primary" onClick={() => { updateTheMaster(); }}>שמור</button>
            </div>
            {thePopUp}
        </div>
    );
}

export default MasterSet;
